"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _globals = require("../../../globals.js");

function _default(palette) {
  var _ref;

  return _ref = {
    palette: palette,
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: 'ease',
    borderColor: palette.elDivider,
    borderWidth: '1px',
    borderStyle: 'none none solid',
    transform: 'scaleX(0)'
  }, (0, _defineProperty2["default"])(_ref, _globals.STATE.HOVER, {
    borderColor: palette.elSecondary,
    borderWidth: '2px',
    borderStyle: 'none none solid',
    transform: 'scaleX(1)'
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.FOCUS, {
    borderColor: palette.elAccent,
    borderWidth: '2px',
    borderStyle: 'none none solid',
    transform: 'scaleX(1)'
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.ERROR, {
    borderColor: palette.elError,
    borderWidth: '2px',
    borderStyle: 'none none solid',
    transform: 'scaleX(1)'
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.DISABLED, {
    borderColor: palette.elDivider,
    borderWidth: '2px',
    borderStyle: 'none none dotted',
    transform: 'scaleX(1)'
  }), _ref;
}